class TranslatableError extends Error {
  constructor(
    public readonly translationKey: string,
    public readonly innerError?: Error | unknown
  ) {
    super(`An error occurred: ${translationKey}.`);
    Object.setPrototypeOf(this, TranslatableError.prototype);
  }
}

export default TranslatableError;
